import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/authGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';

const PREFIX_PREDEFINED_REPORT = 'predefinedReport_';
const predefinedReportMenu: RouteRecordRaw[] = [
  {
    path: '/predefined-report/',
    name: `${PREFIX_PREDEFINED_REPORT}Predefined Report`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_PREDEFINED_REPORT,
    },
    redirect: '/predefined-report/report-issuance-history',
    children: [
      {
        path: 'report-issuance-history',
        name: `${PREFIX_PREDEFINED_REPORT}Report Issuance History`,
        component: () => import('../views/reportIssuanceHistory/ReportIssuanceHistoryView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_PREDEFINED_REPORT_HISTORY,
          viewport: VIEWPORT_TYPE.REALTIME,
        },
      },
      {
        path: 'template-report-export',
        name: `${PREFIX_PREDEFINED_REPORT}Export Predefined Report`,
        component: () => import('../views/exportPredefinedReport/ExportPredefinedReportView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_PREDEFINED_REPORT_EXPORT,
          viewport: VIEWPORT_TYPE.REALTIME,
        },
      },
    ],
  },
];

const getPredefinedReportNaviMenu = () => {
  return extractAccessibleRoutes(predefinedReportMenu);
};

export { predefinedReportMenu, getPredefinedReportNaviMenu };
